import axios from 'axios';
import  '../global';

export const FETCH_COMMITTEES = 'FETCH_COMMITTEES';
export const FETCH_MEETING_DOCUMENTS = 'FETCH_MEETING_DOCUMENTS';
export const FETCH_TOP_MEETINGS = 'FETCH_TOP_MEETING';
export const FETCH_ALL_MEETINGS = 'FETCH_ALL_MEETINGS';
export const FETCH_ALL_COMMITTEE_MEETINGS = 'FETCH_ALL_COMMITTEE_MEETINGS';
export const FETCH_COMMITTEE_MEETING = 'FETCH_COMMITTEE_MEETING';
export const FETCH_COMMITTEE_COLLEAGUES = 'FETCH_COMMITTEE_COLLEAGUES';
export const SEARCH_COMMITTEES = 'SEARCH_COMMITTEES';
export const POLICY_GROUP_FILTER = 'POLICY_GROUP_FILTER';
export const COMMITTEE_FILTER = 'COMMITTEE_FILTER';
export const COMMITTEE_DOCUMENTS = 'COMMITTEE_DOCUMENTS';
export const JOIN_REQUEST = 'JOIN_REQUEST';
export const JOIN_SUCCESS = 'JOIN_SUCCESS';
export const JOIN_ERROR = 'JOIN_ERROR';
export const SWITCH_TAB    = 'SWITCH_TAB';
export const SWITCH_MAIN_TAB    = 'SWITCH_MAIN_TAB';
export const SET_LOADING = 'SET_LOADING';
export const REMOVE_LOADING   = 'REMOVE_LOADING';
export const REMOVE_COMMITTEE = 'REMOVE_COMMITTEE';
export const REMOVE_REQUEST = 'REMOVE_REQUEST';
export const REMOVE_MEETINGS = 'REMOVE_MEETINGS';
export const SHOW_MEETING = 'SHOW_MEETING';
export const HIDE_MEETING = 'HIDE_MEETING';
export const MY_COMMITTEE_TAB = 'MY_COMMITTEE_TAB';
export const MY_COMMITTEES = 'MY_COMMITTEES';
export const COMMITTEE_INVITE_SUCCESS = 'COMMITTEE_INVITE_SUCCESS';
export const COMMITTEE_INVITE_REMOVE = 'COMMITTEE_INVITE_REMOVE';
export const GENERATING_DOCUMENT = 'GENERATING_DOCUMENT';
export const SHOW_ATTENDANCE = 'SHOW_ATTENDANCE';
export const FIRM_INFO = 'FIRM_INFO';
export const PAGINATION = 'PAGINATION';
export const DOCUMENT_FILTER_TYPE = 'DOCUMENT_FILTER_TYPE';
export const CATEGORY_FILTER_TYPE = 'CATEGORY_FILTER_TYPE';
export const CURRENT_DOCUMENT_TOPICS = 'CURRENT_DOCUMENT_TOPICS';
export const REMOVE_DOCUMENT_TOPIC = 'REMOVE_DOCUMENT_TOPIC';
export const DOCUMENT_TAGS = 'DOCUMENT_TAGS';
export const DOCUMENT_FILTERS = 'DOCUMENT_FILTERS';
export const MEETING_FILTERS = 'MEETING_FILTERS';
export const MEETING_FOCUS = 'MEETING_FOCUS';
export const MEETINGS_LOADING = 'MEETINGS_LOADING';
export const DOCUMENTS_LOADING = 'DOCUMENTS_LOADING';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const FETCH_MOST_ENGAGED_COMMITTEES = 'FETCH_MOST_ENGAGED_COMMITTEES';
export const EXPAND_ALL_DOCUMENTS = 'EXPAND_ALL_DOCUMENTS';
export const DIRECT_LINK_COMMITTEE_SWITCH = 'DIRECT_LINK_COMMITTEE_SWITCH';
export const ROLL_CALL_STATE = 'ROLL_CALL_STATE';
export const ATTENDANCE_LIST = 'ATTENDANCE_LIST';
export const POPUP_ERROR = 'POPUP_ERROR';
export const LOADING_DOCUMENT = 'LOADING_DOCUMENT';


export function fetchDocumentTags() {
	return ( dispatch ) => {
		'use strict';

		fetchCommitteeToken.then( ( committeeToken ) => {
			const url = `${getCommitteeUrl()}/documents/tags`;
			const config = api_config( committeeToken );

			axios.get( url, config ).then( response => {
				dispatch( {
					          type: DOCUMENT_TAGS, payload: response.data
				          } );
			} ).catch( function( error ) {
				console.log( error );
			} );
		} );
	};
}

export function switchPage( page, pageNumber ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: PAGINATION, payload: { page, pageNumber }
		          } );

	};
}

export function committeeDirectLinkSwitchTab( value ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: DIRECT_LINK_COMMITTEE_SWITCH, payload: value
		          } );

	};
}

export function setDocumentFilter( key, value, reset = false ) {
	return ( dispatch ) => {
		'use strict';
		let payload = (reset
		              ) ? 'reset' : { key, value };
		dispatch( {
			          type: DOCUMENT_FILTERS, payload
		          } );

	};
}

export function dispatchExpandAllDocuments( value ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: EXPAND_ALL_DOCUMENTS, payload: value
		          } );

	};
}

export function setMeetingFilter( key, value ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: MEETING_FILTERS, payload: { key, value }
		          } );

	};
}


export function fetchAllCommittees() {
	return ( dispatch ) => {
		'use strict';
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/committees`;
		axios.get( url ).then( response => {
			dispatch( {
				          type: FETCH_COMMITTEES, payload: sortCommittees(response.data)
			          } );

		} );
	};
}

export function fetchMyCommittees() {
	return ( dispatch ) => {

		let myCommittees = getMyCommittees();
		dispatch( { type: MY_COMMITTEES, payload: myCommittees } );
		if ( myCommittees.length > 0 ) {
			fetchCommitteeToken.then( function() {
				if ( myCommittees.length > 4 ) {
					dispatch( fetchMostEngagedCommittees( myCommittees ) );
				}

				dispatch( fetchTopMeetings( myCommittees ) );
				dispatch( fetchLatestCommitteeMeetings( myCommittees ) );
				dispatch( fetchCommitteeColleagues( myCommittees ) );
				dispatch( { type: SWITCH_TAB, payload: 'my_committees' } );
			} ).catch( function( error ) {
				console.log( error );
				dispatch( {
					          type: FETCH_TOP_MEETINGS, payload: []
				          } );
			} );

		} else {
			dispatch( {
				          type   : FETCH_TOP_MEETINGS,
				          payload: { meetings: [], total_upcoming_meetings: 0 }
			          } );

		}
	};
}
export function fetchTopMeetings(myCommittees) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then((committeeToken) => {

			if(committeeToken == '' || committeeToken === 0){
				return 0;
			}
			const committeeUrl = getCommitteeUrl();
			const url = `${committeeUrl}/meetings/upcoming/next-five`;
			const urlParams = {};
			const config = api_config(committeeToken);

			myCommittees.forEach((code, element) => {
				const paramElement  = 'ccode['+element+']';
				const paramValue    =  code;
				urlParams[paramElement] = paramValue;
			});
			urlParams['total'] = true;
			const payload = serialize(urlParams);

			axios.post( url, payload, config ).then( response => {
				if ( typeof response.data.meetings !== 'undefined' ) {
					response.data.meetings.forEach( ( info, index ) => {
						if ( info.in_roll_call ) {
							dispatch( dispatchIncludedInRollCall( info.ID ) );
							dispatch( getMeetingAttendance( info.ID ) );
						}
					} );
				}

				dispatch({
					         type:FETCH_TOP_MEETINGS,
					         payload:  response.data
				         });


			} );
		}).catch(function(error) {
			// catch error.
		});
	};
}

export function fetchMostEngagedCommittees( myCommittees ) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken ) => {

			if ( committeeToken === '' || committeeToken === 0 ) {
				return 0;
			}
			const committeeUrl = getCommitteeUrl();
			const url = `${committeeUrl}/committees/most-engaged`;
			const urlParams = {};
			const config = api_config( committeeToken );

			myCommittees.forEach( ( code, element ) => {
				const paramElement = 'ccode[' + element + ']';
				const paramValue = code;
				urlParams[ paramElement ] = paramValue;
			} );
			urlParams[ 'party_id' ] = getImisInfo().ContactMaster; //gets total amount of upcoming meetings

			const payload = serialize( urlParams );
			axios.post( url, payload, config ).then( response => {
				dispatch( {
					          type   : FETCH_MOST_ENGAGED_COMMITTEES,
					          payload: response.data
				          } );
			} );
		} ).catch( function( error ) {
			console.log( error );
			// catch error.
		} );
	};
}

export function fetchAllCommitteeMeetings( filters = {}, min = 0, max_results_found = false ) {
	return ( dispatch ) => {
		'use strict';

		fetchCommitteeToken.then( ( committeeToken ) => {
			dispatch( meetingsLoading( true ) );
			const url = `${getCommitteeUrl()}/meetings`;
			const myCommittees = getMyCommittees();
			const urlParams = {};
			const config = api_config( committeeToken );
			//set my committees
			myCommittees.forEach( ( committee, element ) => {
				const paramElement = 'ccode[' + element + ']';
				const paramValue = committee;
				urlParams[ paramElement ] = paramValue;
			} );
			//set search properties
			for ( const property in filters ) {
				if ( filters[ property ].length > 0 ) {
					const paramElement = 'search[' + property + ']';
					const paramValue = filters[ property ];
					urlParams[ paramElement ] = paramValue;
				}
			}
			if ( max_results_found !== false ) {
				urlParams[ 'max_results_found' ] = true;
			}
			urlParams[ 'min' ] = min;
			urlParams[ 'max' ] = 6;
			const payload = serialize( urlParams );

			axios.post( url, payload, config ).then( response => {
				dispatch( meetingsLoading( false ) );
				var meetings = (response.status === 200
				               ) ? response.data : {};
				dispatch( {
					          type   : FETCH_ALL_COMMITTEE_MEETINGS,
					          payload: meetings
				          } );
				if ( response.status === 200 ) {
					let upcoming_meetings = (typeof meetings.upcoming_meetings !== 'undefined'
					                        ) ? meetings.upcoming_meetings : [];
					let past_meetings = (typeof meetings.past_meetings !== 'undefined'
					                    ) ? meetings.past_meetings : [];
					let all_meetings = upcoming_meetings.concat( past_meetings );
					dispatch( fetchDocuments( all_meetings ) );
				}

			} );

		} ).catch( function( error ) {
			console.log( error );
		} );
	};
}

export function fetchPastMeetings( filters = {}, min = 0, max_results_found = true ) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken ) => {
			//TODO, this can be refactored as plenty of this code is similar to fetchAllCommitteeMeetings. Maybe just have one function and pass param for past meetings or not.
			dispatch( meetingsLoading( true ) );
			const url = `${getCommitteeUrl()}/meetings/past`;
			const myCommittees = getMyCommittees();
			const urlParams = {};
			const config = api_config( committeeToken );
			var meetings = '';
			//set my committees
			myCommittees.forEach( ( committee, element ) => {
				const paramElement = 'ccode[' + element + ']';
				const paramValue = committee;
				urlParams[ paramElement ] = paramValue;
			} );
			//set search properties
			for ( const property in filters ) {
				if ( filters[ property ].length > 0 ) {
					const paramElement = 'search[' + property + ']';
					const paramValue = filters[ property ];
					urlParams[ paramElement ] = paramValue;
				}
			}
			if ( max_results_found !== false ) {
				urlParams[ 'max_results_found' ] = true;
			}
			urlParams[ 'min' ] = min;
			urlParams[ 'max' ] = 6;
			const payload = serialize( urlParams );

			axios.post( url, payload, config ).then( response => {
				meetings = response.data;
				dispatch( {
					          type   : FETCH_ALL_COMMITTEE_MEETINGS,
					          payload: response.data
				          } );
				dispatch( fetchDocuments( meetings.past_meetings ) );
				dispatch( meetingsLoading( false ) );

			} );

		} ).catch( function( error ) {
			console.log( error );
		} );
	};
}

export function meetingsLoading( value ) {
	return ( dispatch ) => {
		dispatch( {
			          type: MEETINGS_LOADING, payload: value
		          } );
	};
}

export function documentsLoading( value ) {
	return ( dispatch ) => {
		dispatch( {
			          type: DOCUMENTS_LOADING, payload: value
		          } );
	};
}

export function fetchDocuments( meetings ) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken ) => {
			const url = `${getCommitteeUrl()}/documents/`;
			const urlParams = {};
			meetings.forEach( ( meeting, element ) => {
				const paramElement = 'meeting_id[' + element + ']';
				const paramValue = meeting.ID;
				urlParams[ paramElement ] = paramValue;
			} );
			const payload = serialize( urlParams );
			const config = api_config( committeeToken );

			axios.post( url, payload, config ).then( response => {
				//fetch committee Documents here.
				fetchCommitteeDocuments( {}, response );
				dispatch( {
					          type   : FETCH_MEETING_DOCUMENTS,
					          payload: response.data
				          } );
			} );
		} ).catch( function( error ) {
			console.log( error );
		} );
	};
}

export function setDocumentType( documentType ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: DOCUMENT_FILTER_TYPE, payload: documentType } );
	};
}

export function setCurrentDocumentTopics( topic ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: CURRENT_DOCUMENT_TOPICS, payload: topic } );
	};
}

export function removeDocumentTopic( topic ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: REMOVE_DOCUMENT_TOPIC, payload: topic } );
	};
}

export function toggleFilterButton( page, toggle ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( {
			          type: TOGGLE_FILTER, payload: { page, toggle }
		          } );
	};
}

export function fetchCommitteeDocuments( filters = {}, min = 0, max_results_found = false ) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken ) => {
			dispatch( documentsLoading( true ) );
			const url = `${getCommitteeUrl()}/documents/committee-documents`;
			const urlParams = {};
			const committees = getMyCommittees();

			if ( typeof filters.committee !== 'undefined' && filters.committee !== '' ) {
				urlParams[ 'ccode[0]' ] = filters.committee;
			} else {
				committees.forEach( ( ccode, element ) => {
					const paramElement = 'ccode[' + element + ']';
					const paramValue = ccode;
					urlParams[ paramElement ] = paramValue;
				} );
			}
			for ( const property in filters ) {
				if ( filters[ property ].length > 0 ) {
					if ( Array.isArray( filters[ property ] ) ) {
						filters[ property ].forEach( ( value, index ) => {
							const paramElement = 'search[' + property + '][' + index + ']';
							const paramValue = filters[ property ][ index ];
							urlParams[ paramElement ] = paramValue;
						} );
					} else {
						const paramElement = 'search[' + property + ']';
						const paramValue = filters[ property ];
						urlParams[ paramElement ] = paramValue;
					}
				}
			}

			urlParams[ 'min' ] = min;
			urlParams[ 'max' ] = 15;
			if ( max_results_found !== false ) {
				urlParams[ 'max_results_found' ] = true;
			}
			const payload = serialize( urlParams );
			const config = api_config( committeeToken );

			axios.post( url, payload, config ).then( response => {
				if ( response.data.length === 0 ) {
					return 0;
				} else {
					dispatch( {
						          type   : COMMITTEE_DOCUMENTS,
						          payload: response.data
					          } );
				}
				dispatch( documentsLoading( false ) );

			} ).catch( function( error ) {
				dispatch( documentsLoading( false ) );
				console.log( error );
			} );

		} );

	};

}

function requestLogDownload( document_id ) {
	fetchCommitteeToken.then( ( committeeToken ) => {
		const url = `${getCommitteeUrl()}/documents/log-download`;
		const urlParams = {};
		const config = api_config( committeeToken );
		urlParams[ 'document_id' ] = document_id;
		const payload = serialize( urlParams );
		axios.post( url, payload, config )
		     .then( response => console.log( response ) );
	} ).catch( function( error ) {
		console.log( error );
	} );
}

export function fetchLatestCommitteeMeetings( myCommittees ) {

	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken ) => {
			const committeeUrl = getCommitteeUrl();
			const url = `${committeeUrl}/meetings/upcoming-past-meeting`;
			const urlParams = {};

			if ( committeeToken === '' || committeeToken === 0 ) {
				return 0;
			}
			myCommittees.forEach( ( code, element ) => {
				const paramElement = 'ccode[' + element + ']';
				const paramValue    =  code;
				urlParams[ paramElement ] = paramValue;
			} );
			const payload = serialize( urlParams );
			let config = api_config( committeeToken );
			axios.post( url, payload, config ).then( response => {
				dispatch( {
					          type: FETCH_ALL_MEETINGS, payload: response.data
				          } );

			} );
		} ).catch( function( error ) {
			console.log(error);
		} );
	};
}

export function findMeeting( meet_id ) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken, rejected ) => {
			if ( committeeToken === '' || committeeToken === 0 ) {
				return 0;
			}
			const url = `${getCommitteeUrl()}/meetings/meeting?id=` + meet_id;
			const config = api_config( committeeToken );

			axios.get( url, config ).then( response => {
				console.log( 'here' );
				dispatch( setMeetingFocus( response.data ) );
				dispatch( fetchDocuments( [ response.data ] ) );
			} );
		} ).catch( function( error ) {
			console.log( error );
		} );
	};
}

export function setMeetingFocus( meeting ) {
	return ( dispatch ) => {
		dispatch( {
			          type: MEETING_FOCUS, payload: meeting

		          } );
	};
}

export function switchMainTabDispatch( tabName ) {
	return ( dispatch ) => {
		if ( tabName === '' || typeof tabName === 'undefined' ) {
			tabName = 'My Dashboard';
		}
		dispatch( {
			          type: SWITCH_MAIN_TAB, payload: tabName
		          } );
	};
}

export function setCategoryType( categoryType ) {
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: CATEGORY_FILTER_TYPE, payload: categoryType } );
	};
}

export function filterByCommittee( committee ) {
	return ( dispatch ) => {
		dispatch( {
			          type: COMMITTEE_FILTER, payload: committee
		          } );
	};
}

export function rsvpUser( ccode, meeting_id, attendance ) {
	return ( dispatch ) => {
		const urlParams = {};
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/rsvp/`;
		urlParams[ 'meet_id' ] = meeting_id;
		urlParams[ 'ccode' ] = ccode;
		urlParams[ 'email' ] = getImisInfo().UserName.toLowerCase();
		urlParams[ 'attendance_type' ] = attendance;
		const payload = serialize( urlParams );
		fetchCommitteeToken.then( ( committeeToken ) => {
			let config = api_config( committeeToken );
			axios.post( url, payload, config ).then( response => {
				console.log( response );
				//todo check response

			} );
		} ).catch( function( error ) {
			console.log( error );
		} );
	};

}

export function downloadDocument( file_name, download_file_name, document_id, bucket_name ) {
	return ( dispatch ) => {
		fetchCommitteeToken.then( ( committeeToken ) => {
			const url = `${getCommitteeUrl()}/documents/generate-url`;
			const urlParams = {};
			const config = api_config( committeeToken );
			urlParams[ 'file_name' ] = file_name;
			urlParams[ 'download_file_name' ] = download_file_name;
			urlParams[ 'bucket_name' ] = bucket_name;
			const payload = serialize( urlParams );
			dispatch( documentLoading( file_name ) );
			axios.post( url, payload, config ).then( response => {
				dispatch( documentLoading( file_name ) );
				dispatch( openWindow( response.data ) );
			} );
			requestLogDownload( document_id );
		} ).catch( function( error ) {
			console.log( error );
		} );
	};
}

function documentLoading( file_name ) {
	return { payload: file_name, type: 'GENERATING_DOCUMENT' };
}

function openWindow( url ) {
	const open_url = url;
	location.href = open_url;
	return { payload: '', type: 'GENERATING_DOCUMENT' };
}


export function addUserToRollCall( member_info, meet_id) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( (committeeToken, rejected) => {
			if(committeeToken === '' || committeeToken === 0){
				return 0;
			}
			const committeeUrl = getCommitteeUrl();
			const url = `${committeeUrl}/roll-call/admission?meet_id=${meet_id}&is_from_committee_dashboard`;
			const config = api_config(committeeToken);
			axios.post( url, serialize( member_info ), config )
			     .then( response => {
				     //TODO do error handling here.
				     if ( response.status === 200 ) {
					     dispatch( dispatchIncludedInRollCall(meet_id));
					     dispatch(getMeetingAttendance(meet_id));

				     }
			     } );
		}).catch(function(error) {
			console.log(error);
		})

	};
}

export function dispatchIncludedInRollCall(meet_id){
	return (dispatch) => {
		dispatch( {
			          type: ROLL_CALL_STATE, payload: meet_id
		          } );
	}
}

export function fetchCommitteeMeetings(ccode){
	return (dispatch) => {
		'use strict';
		fetchCommitteeToken.then( (committeeToken, rejected) => {
			if(committeeToken === '' || committeeToken === 0){
				return 0;
			}

			const url   = `${getCommitteeUrl()}/meetings/upcoming/committee`;
			const urlParams = {};
			const config = api_config(committeeToken);
			urlParams['ccode'] = ccode;
			const payload = serialize(urlParams);

			axios.post( url, payload, config ).then( response => {
				dispatch({
					         type:FETCH_COMMITTEE_MEETING,
					         payload: {
						         ccode : ccode,
						         data : response.data
					         }
				         });
			} )
		}).catch(function(error) {
			console.log(error);
		})
	}
}

export function unsetCommitteeTab(){
	return (dispatch) => {
		dispatch({
			         type:'MY_COMMITTEE_TAB', payload:false
		         });
	}
}

export function showCommitteeMeetings(ccode){
	return (dispatch) => {
		'use strict';
		dispatch({
				         type:SHOW_MEETING,
				         payload: ccode
			         });
	}
}

export function hideCommitteeMeetings(ccode){
	return (dispatch) => {
		'use strict';
		dispatch({
			         type: HIDE_MEETING,
			         payload: ccode
         });
	}
}

const fetchCommitteeToken = new Promise (function (resolve, reject) {
	if ( !isUserLoggedIn() ) {
		return 0;
	}

	var committeeToken = '';
	var userStorageEmail = localStorage.getItem( 'tokenEmail' );
	var currentEmail = getImisInfo().UserName;

	if ( localStorage.getItem( 'committeeToken' ) && (userStorageEmail === currentEmail) ) {
		committeeToken = localStorage.getItem( 'committeeToken' );
		resolve( committeeToken );
	} else {

		const urlParams = {};
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/auth`;
		const imisInfo = getImisInfo();

		for ( let element in imisInfo ) {
			const paramElement  = element;
			const paramValue    = imisInfo[ element ];
			urlParams[paramElement] = paramValue;
		}
		const payload = serialize(urlParams);

		axios.post( url, payload ).then( response => {

			committeeToken = response.data.token;
			setTokenLocalStorage(committeeToken,currentEmail);
			resolve( committeeToken );

		} ).catch((error)=> {
			reject(false);
		});
	}
});




export function joinCommittee( code, partyId, myCommittees, openToNonMembers ) {

	return ( dispatch ) => {
		if(is_member() === false && !openToNonMembers){
			return 0;
		}
		const source = 'ISDA_COMMITTEE_DASHBOARD';
		const url = `${wpApiSettings.root}isda/v1/committees`;
		axios.post( url, { code, partyId, source }, get_config() )
		     .then( response => {

				 switch(response.data.message){
					 case 'request_sent':
			            dispatch({type:JOIN_REQUEST, payload:code});
					 break;

					 case 'join_success':
						 dispatch({type:JOIN_SUCCESS, payload:code});
						 dispatch(fetchCommitteeMeetings(code));
						 myCommittees.push(code);
						 dispatch(fetchTopMeetings(myCommittees));
						 break;

					 default:
						 let payload = [];
						 payload[ code ] = response.data.message;
					     dispatch({ type: JOIN_ERROR, payload });
					 break;
				 }
				 dispatch(removeLoadingState(code));

		     } );
	}
}

function sortCommittees(committees){
	let policyGroups = [];
	let newComm = [];

	  committees.forEach((committee)=>{
		  if(!policyGroups.includes(committee.policyGroup)){
			  policyGroups.push(committee.policyGroup);
		  }
	  });

	newComm = policyGroups.map(group => {
		let groupComm = committees.filter(committee => {
			return committee.policyGroup === group;
		});
		groupComm.sort(function(a, b) {
			var nameA = a.title.toUpperCase(); // ignore upper and lowercase
			var nameB = b.title.toUpperCase(); // ignore upper and lowercase
			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}
			// names must be equal
			return 0;
		});
		return groupComm;
	});
		   //removed all arrays within the array.
	return newComm.flatten();
}

export function getMeetingAttendance( meet_id ) {
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then( ( committeeToken, rejected ) => {
			if ( committeeToken === '' || committeeToken === 0 ) {
				return 0;
			}
			const committeeUrl = getCommitteeUrl();
			const url = `${committeeUrl}/roll-call/attendance-list?meet_id=${meet_id}&is_from_committee_dashboard=true`;
			const config = api_config( committeeToken );
			axios.get( url, config ).then( response => {
				//TODO do error handling here.
				if ( response.status === 200 ) {
					dispatch( {
						          type   : ATTENDANCE_LIST,
						          payload: {meet_id: meet_id, attendance: response.data.attendance}
					          } );
				}
			} );
		} ).catch( function( error ) {
			console.log( error );
		} );

	};
}

export function setLoadingState(code){
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: SET_LOADING, payload: code } );
	}
}

export function removeLoadingState(code){
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: REMOVE_LOADING, payload: code } );
	}
}


export function setShowMeetingState(code, meetings){
	return (dispatch) => {
		'use strict';
		dispatch({
			type:SET_SHOW_MEETING,
            payload: {code, meetings}
        });
	}
}

export function removeCalendarMessage(meeting_id){
	return (dispatch) => {
		'use strict';
		dispatch({
			         type:SET_SHOW_MEETING,
			         payload: {code, meetings}
		         });
	}
}

export function getCalendarInvite(meeting_id,ccode,loading_id, main_committee_code){
	return (dispatch) => {
		fetchCommitteeToken.then( ( committeeToken ) => {
			'use strict';
			const config = api_config( committeeToken );
			const url = `${ getCommitteeUrl() }/invites/`;
			const urlParams = {};
			urlParams[ 'ccode' ] = ccode;
			urlParams[ 'meeting_id' ] = meeting_id;
			urlParams[ 'email' ] = getImisInfo().UserName;
			urlParams[ 'main_committee_code' ] = main_committee_code;
			const payload = serialize( urlParams );

			axios.post( url, payload, config )
			     .then( response => {

			     	//todo if response success.
			     	dispatch({
				               type:REMOVE_LOADING,
				               payload: loading_id
			               });

			     	dispatch({
				               type:COMMITTEE_INVITE_SUCCESS,
				               payload: {meeting_id,
				                         'status':response.status
				               }
			               });
	               })
			     } ).catch(function(error){
			console.log(error);
		});
	}
}

export function fetchCommitteeColleagues(myCommittees){
	return ( dispatch ) => {
		'use strict';
		fetchCommitteeToken.then((committeeToken) => {

			if(committeeToken == '' || committeeToken === 0){
				return 0;
			}
			const committeeUrl = getCommitteeUrl();
			const url = `${committeeUrl}/colleagues`;
			const urlParams = {};
			const config = api_config(committeeToken);
			myCommittees.forEach((code, element) => {
				const paramElement  = 'ccode['+element+']';
				const paramValue    =  code;
				urlParams[paramElement] = paramValue;
			});
			urlParams['party_id'] = getImisInfo().ContactMaster;
			const payload = serialize(urlParams);

			axios.post( url, payload, config ).then( response => {
				dispatch({
					         type:FETCH_COMMITTEE_COLLEAGUES,
					         payload:  response.data
				         });

			} );
		}).catch(function(error) {
			// catch error.
		});
	};
}

export function removeCommittee(code,partyId,myCommittees){
	return (dispatch) => {
		const url = `${wpApiSettings.root}isda/v1/committees?code=${code}&partyId=${partyId}&source=ISDA_COMMITTEE_DASHBOARD`;
		axios.delete( url, get_config())
		     .then( response => {
			     if(response.data.code === 200){
			     	switch (response.data.message){
				        case 'you have left the committee':

				        	dispatch({type:REMOVE_COMMITTEE,payload:code});
				        	dispatch({type:REMOVE_MEETINGS, payload:code});
				        	myCommittees.splice(myCommittees.indexOf(code),1);
				        	dispatch(fetchTopMeetings(myCommittees));

		                break;

				        case 'request_cancelled':

					         dispatch({type:REMOVE_REQUEST,payload:code});

		                break;
			        }
				     dispatch(removeLoadingState(code));
			     }
		     } );
	}
}

export function getAgendaPDF( meeting_id ) {
	return ( dispatch ) => {

		const urlParams = {};
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/documents/download-agenda`;
		urlParams[ 'meeting_id' ] = meeting_id;
		const payload = serialize( urlParams );
		fetchCommitteeToken.then( ( committeeToken ) => {
			let config = api_config( committeeToken );
			axios.post( url, payload, config ).then( response => {
				dispatch( setDocumentLoading() );
				const agendaurl = response.data;
				let windowOpen = window.open( agendaurl );
				if ( windowOpen === null || !windowOpen || windowOpen.closed || typeof windowOpen.closed == 'undefined' ) {
					dispatch( popUpError( meeting_id ) );
				} else {
					dispatch( popUpError() );
				}

			} );
		} ).catch( function( error ) {
			console.log( error );
		} );
	};

}

export function popUpError(meeting_id = ''){
	return (dispatch) => {
		dispatch({
			         type:POPUP_ERROR,
			         payload: meeting_id
		         })
	}
}

export function switchTabDispatch(tabName){
	return (dispatch) => {
		if(tabName === '' || typeof tabName === 'undefined'){
			tabName = 'all_committees';
		}
		dispatch( {
			          type: SWITCH_TAB,
			          payload: tabName
		          } );
	}
}

export function searchFunction(keyword){
	return (dispatch) => {
		dispatch({
			type:SEARCH_COMMITTEES,
			payload:keyword
		         })
	}
}

export function setDocumentLoading(meeting_id = ''){
	return (dispatch) => {
		dispatch({
			         type:LOADING_DOCUMENT,
			         payload: meeting_id
		         });
	}

}


export function isUserLoggedIn(){
	return containsClass( document.body, 'logged-in' );
}

export function getMembershipEmail(){
	return get_membership_email();
}


export function containsClass( elem, yourClass ) {
	if ( !elem || typeof yourClass !== 'string' ) {
		return false;
	} else if ( elem.className && elem.className.trim()
	                                  .split( /\s+/gi )
	                                  .indexOf( yourClass ) > -1 ) {
		return true;
	} else {
		return false;
	}
}

export function policyGroupFilter(policyGroup){
	return (dispatch) => {
		dispatch( {
			          type: POLICY_GROUP_FILTER, payload: policyGroup
		          } );
	}
}

function get_config(){
	let config = {
		headers: {
			'X-WP-Nonce': wpApiSettings.nonce
		}
	}
	return config;
}

function api_config(token){
	let config = {
		headers: {
			'Authorization': 'Bearer ' + token
		}
	}
	return config;
}



